var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { Focusable } from "@/common/mixins/Focusable";
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import PlainTextControl from '@/common/components/PlainTextControl.vue';
import HeaderControl from '@/common/components/HeaderControl.vue';
import TextLabelRow from '@/common/components/TextLabelRow.vue';
import AidYearSelect from '@/template/components/paymentRequestER/AidYearSelect.vue';
import RadioButtonRow from '@/common/components/RadioButtonRow.vue';
import NumericInputRow from '@/common/components/NumericInputRow.vue';
import AttachmentTable from '@/common/components/AttachmentTable.vue';
import { PaymentRequestExpenseReport } from '@/common/types/PaymentRequestExpenseReport';
import moment from 'moment';
import EntityService from '@/common/services/EntityService';
import { Savable } from '@/common/mixins/Savable';
import { PaymentMethod } from '@/common/types/PaymentMethod';
import { AidType } from '@/common/types/AidType';
var PaymentRequestExpenseReportView = /** @class */ (function (_super) {
    __extends(PaymentRequestExpenseReportView, _super);
    function PaymentRequestExpenseReportView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entityService = new EntityService();
        _this.expenseRadioButtonValueChanged = null;
        _this.paymentRadioButtonValueChanged = null;
        _this.expenditureCleared = 0;
        return _this;
    }
    PaymentRequestExpenseReportView.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var prevented, id, aidYearId, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.preventSendingIfNecessary()];
                    case 1:
                        prevented = _b.sent();
                        if (!prevented) {
                            if (!this.allowPaymentRequest) {
                                if (this.paymentRequestER.isPaymentRequest == true || this.paymentRequestER.isPaymentRequest == null) {
                                    this.paymentRequestER.isPaymentRequest = false;
                                    this.paymentRequestER.requestedAmount = null;
                                    this.forceSave();
                                }
                            }
                            if (!this.allowExpenseReport) {
                                if (this.paymentRequestER.isExpenseReport == true || this.paymentRequestER.isExpenseReport == null) {
                                    this.paymentRequestER.isExpenseReport = false;
                                    this.clearExpenseReport();
                                    this.forceSave();
                                }
                            }
                        }
                        id = this.paymentRequestER.id;
                        aidYearId = this.paymentRequestER.expenseReport.crmAidYearId;
                        if (!(this.paymentRequestER.isExpenseReport && aidYearId)) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this.entityService.getPreviouslyClearedExpenditure(id, aidYearId)];
                    case 2:
                        _a.expenditureCleared = _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PaymentRequestExpenseReportView.prototype.mounted = function () {
        this.focusOnFirstTag("h1");
    };
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "paymentMethodChanged", {
        get: function () {
            return this.aidTargetWithAmounts && this.aidTargetWithAmounts.paymentMethod != PaymentMethod.PaymentRequest;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "hasActivePaymentBan", {
        get: function () {
            return this.aidTargetWithAmounts.paymentBan;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "aidTargetWithAmounts", {
        get: function () {
            return this.paymentRequestER.aidTargetWithAmounts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "noWithdrawable", {
        get: function () {
            return this.aidTargetWithAmounts.withdrawableAmount == 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "allowPaymentRequest", {
        get: function () {
            return this.paymentRequestER.canIncludePaymentRequest && this.aidTargetWithAmounts.withdrawableAmount > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "allowExpenseReport", {
        get: function () {
            return this.paymentRequestER.canIncludeExpenseReport;
        },
        enumerable: false,
        configurable: true
    });
    PaymentRequestExpenseReportView.prototype.preventSendingIfNecessary = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.paymentMethodChanged) return [3 /*break*/, 2];
                        this.$store.commit("vuexPageModule/SET_CUSTOMREADONLY", true);
                        return [4 /*yield*/, this.$store.dispatch("vuexPageModule/setPreventSending", "PaymentRequestER.PaymentMethodChanged")];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        if (!(!this.allowPaymentRequest && !this.allowExpenseReport)) return [3 /*break*/, 4];
                        this.$store.commit("vuexPageModule/SET_CUSTOMREADONLY", true);
                        return [4 /*yield*/, this.$store.dispatch("vuexPageModule/setPreventSending", "PaymentRequestER.BothDisabled")];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 4: return [2 /*return*/, false];
                }
            });
        });
    };
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "expenseReport", {
        get: function () {
            return this.paymentRequestER.expenseReport;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "totalExpensesToReport", {
        get: function () {
            if (this.expenseReport.aidTargetExpenses != null) {
                var profit = this.expenseReport.aidTargetOtherProfit ? this.expenseReport.aidTargetOtherProfit : 0;
                if (this.expenseReport.aidTargetExpenses > profit) {
                    return this.expenseReport.aidTargetExpenses - profit;
                }
            }
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "aidTargetNumber", {
        get: function () {
            return this.paymentRequestER.record.aidTargetNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "withdrawableAmount", {
        get: function () {
            return this.aidTargetWithAmounts.withdrawableAmount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "aidYearAmounts", {
        get: function () {
            return this.aidTargetWithAmounts.aidYearAmounts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "accountingPeriodOptions", {
        get: function () {
            return this.aidTargetWithAmounts.aidYearsForExpenseReport;
        },
        enumerable: false,
        configurable: true
    });
    PaymentRequestExpenseReportView.prototype.onAccountingPeriodChange = function (newId) {
        return __awaiter(this, void 0, void 0, function () {
            var id, _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        id = this.paymentRequestER.id;
                        _a = this;
                        return [4 /*yield*/, this.entityService.getPreviouslyClearedExpenditure(id, newId)];
                    case 1:
                        _a.expenditureCleared = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        console.error(e_1);
                        this.expenditureCleared = 0;
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Filters accounting period options to find a match.
    PaymentRequestExpenseReportView.prototype.getAidYearById = function (id) {
        return this.aidTargetWithAmounts.aidYearsForExpenseReport.find(function (o) { return o.crmId == id; });
    };
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "aidType", {
        get: function () {
            return this.paymentRequestER.aidType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "attachmentsTitle", {
        get: function () {
            if (this.aidType == AidType.B) {
                return "PaymentRequestER.ExpenseReport.AttachmentsB";
            }
            return "PaymentRequestER.ExpenseReport.Attachments";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "accountingPeriod", {
        // If aidyear is not found in aidtarget's aid years with expenditure to clear, returns null.
        get: function () {
            if (this.expenseReport.crmAidYearId) {
                if (this.aidTargetWithAmounts) {
                    var aidYear = this.getAidYearById(this.expenseReport.crmAidYearId);
                    return aidYear;
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    PaymentRequestExpenseReportView.prototype.setAccountingPeriod = function (input) {
        if (input == null) {
            this.expenseReport.crmAidYearId = null;
            this.expenseReport.year = null;
        }
        else {
            this.expenseReport.crmAidYearId = input.crmId;
            this.expenseReport.year = input.year;
        }
    };
    PaymentRequestExpenseReportView.prototype.getAidYearAmountTitle = function (aidYearAmount) {
        var lastAidUseDateStr = moment(aidYearAmount.lastAidUseDate).format("DD.MM.YYYY");
        return "" + this.$t("PaymentPlan.Information.Until", null, [lastAidUseDateStr]);
    };
    PaymentRequestExpenseReportView.prototype.onIsPaymentRequestChange = function () {
        if (!this.paymentRequestER.isPaymentRequest && this.paymentRequestER.requestedAmount != null) {
            if (confirm(this.$i18n.t("PaymentRequestER.Confirm.PaymentRequest").toString())) {
                this.paymentRequestER.requestedAmount = null;
            }
            else {
                this.paymentRequestER.isPaymentRequest = true;
                this.paymentRadioButtonValueChanged = Date();
            }
        }
    };
    Object.defineProperty(PaymentRequestExpenseReportView.prototype, "expenseReportModified", {
        get: function () {
            return !!this.expenseReport.crmAidYearId
                || this.expenseReport.aidTargetExpenses != null
                || this.expenseReport.aidTargetOtherProfit != null
                || this.expenseReport.attachments.some(function (x) { return !!x.blobUri || !!x.name; });
        },
        enumerable: false,
        configurable: true
    });
    PaymentRequestExpenseReportView.prototype.clearExpenseReport = function () {
        this.expenseReport.aidTargetExpenses = null;
        this.expenseReport.aidTargetOtherProfit = null;
        this.expenseReport.crmAidYearId = null;
        this.expenseReport.year = null;
        this.expenseReport.attachments = [];
    };
    PaymentRequestExpenseReportView.prototype.onIsExpenseReportChange = function (value) {
        // Always clear attachments if selection is false.
        if (!value) {
            if (this.expenseReportModified) {
                if (confirm(this.$i18n.t("PaymentRequestER.Confirm.ExpenseReport").toString())) {
                    this.clearExpenseReport();
                }
                else {
                    this.paymentRequestER.isExpenseReport = true;
                    this.expenseRadioButtonValueChanged = Date();
                }
            }
            else {
                this.expenseReport.attachments = [];
            }
        }
        if (value && this.expenseReport.attachments.length == 0) {
            this.initializeAttachments();
        }
    };
    PaymentRequestExpenseReportView.prototype.initializeAttachments = function () {
        var displayKey = null;
        var attachmentName = null;
        var required = false;
        if (this.aidType != AidType.B) {
            displayKey = "PaymentRequestER.ExpenseReport.IncomeStatement";
            required = true;
            attachmentName = this.$i18n.t(displayKey, "fi"); // Set name in finnish cause it's set for D360.
        }
        this.expenseReport.attachments.push({ name: attachmentName, displayKey: displayKey, isRequired: required, fileNameWithExtension: null, blobUri: null });
    };
    var _a;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof PaymentRequestExpenseReport !== "undefined" && PaymentRequestExpenseReport) === "function" ? _a : Object)
    ], PaymentRequestExpenseReportView.prototype, "paymentRequestER", void 0);
    __decorate([
        Watch("expenseReport.crmAidYearId"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], PaymentRequestExpenseReportView.prototype, "onAccountingPeriodChange", null);
    __decorate([
        Watch("paymentRequestER.isPaymentRequest"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PaymentRequestExpenseReportView.prototype, "onIsPaymentRequestChange", null);
    __decorate([
        Watch("paymentRequestER.isExpenseReport"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PaymentRequestExpenseReportView.prototype, "onIsExpenseReportChange", null);
    PaymentRequestExpenseReportView = __decorate([
        Component({
            name: "PaymentRequestExpenseReportView",
            components: {
                TextAreaRow: TextAreaRow,
                RadioButtonRow: RadioButtonRow,
                PlainTextControl: PlainTextControl,
                HeaderControl: HeaderControl,
                TextLabelRow: TextLabelRow,
                NumericInputRow: NumericInputRow,
                AidYearSelect: AidYearSelect,
                AttachmentTable: AttachmentTable
            }
        })
    ], PaymentRequestExpenseReportView);
    return PaymentRequestExpenseReportView;
}(Mixins(Focusable, Savable)));
export default PaymentRequestExpenseReportView;
